import React from 'react';
import { Helmet } from 'react-helmet';


const PageBrandGuidelines = () => {
    const [display, setDisplay] = React.useState('none');

    const handleClick = () => {
        setDisplay(display === 'none' ? 'block' : 'none');
    }

    // hues = [270 - i * (270 / 11) for i in range(12)]
    // saturation = 1.0
    // lightness = 0.5
    const rayData = [
        { color: '#7F00FF', name: 'Violet Veil', percentage: 42, title: 'AI-Powered Draft & Summarization', description: 'Generates draft emails and summarizes long conversation threads using AI.' },
        { color: '#1700FF', name: 'Orchid Pulse', percentage: 44, title: 'Real-Time Translation', description: 'Instantly translates and relays emails between English and French, powering bilingual workflows.' },
        { color: '#0000FF', name: 'Indigo Insight', percentage: 46, title: 'Smart Categorization', description: 'Automatically tags and folders emails based on content and context.' },
        { color: '#007FFF', name: 'Sapphire Beam', percentage: 47, title: 'Microsoft 365 Integration', description: 'Seamless, centralized control through Exchange Admin Center without plugins.' },
        { color: '#00FFFF', name: 'Cyan Refract', percentage: 49, title: 'Bilingual Harmony', description: 'Tailored for English-French Canadian teams, ensuring linguistic consistency.' },
        { color: '#00FF7F', name: 'Lumen Lime', percentage: 51, title: 'Sentiment Analysis', description: 'Scans message tone and flags potential escalations, improving customer engagement.' },
        { color: '#00FF00', name: 'Chartreuse Guard', percentage: 53, title: 'Anti-Spam & Phishing Protection', description: 'Proactively blocks spam, phishing attempts, and malicious content.' },
        { color: '#7FFF00', name: 'Sun-Spark Yellow', percentage: 55, title: 'Compliance & QA', description: 'Audit-ready logs and rule-based scanning for data leaks and policy adherence.' },
        { color: '#FFFF00', name: 'Amber Orbit', percentage: 56, title: 'Send-Later Scheduling', description: 'Schedules emails for optimal send times and follow-up reminders.' },
        { color: '#FFBF00', name: 'Coral Flash', percentage: 58, title: 'Leak Detection', description: 'Identifies exposed credentials or sensitive data in outgoing emails, generating alerts.' },
        { color: '#FF6800', name: 'Ember Edge', percentage: 60, title: 'Priority Inbox & Smart Notifications', description: 'Highlights critical emails and delivers context-aware alerts.' },
        { color: '#FF0000', name: 'Crimson Circuit', percentage: 62, title: 'Analytics & Reporting', description: 'Provides detailed email engagement metrics, delivery stats, and compliance reports.' }
    ]

    const drawLogo = () => (
        <div
            className="d-flex justify-content-center mb-5 border border-1 border-secondary position-relative"
            style={{
                //backgroundImage: display !== 'none' ? `url(/logo.png)` : 'none',
                //backgroundSize: '62%',
                //backgroundPosition: 'center',
                //backgroundRepeat: 'no-repeat',
                width: '800px',
                height: '800px',
                cursor: 'pointer',
            }}
        >
            <div className="position-absolute text-end text-secondary fw-lighter fs-5 px-1" style={{ right: 0, top: 0 }}>Click here</div>
            <svg
                width="800"
                height="800"
                style={{ backgroundColor: display === 'none' ? 'transparent' : '#003B7F88' }}
            >
                <defs>
                    <mask id="donutMask">
                        <rect width="100%" height="100%" fill="white" />
                        <circle cx="400" cy="400" r="63" fill="black" />
                    </mask>
                    <style>{`
          line, circle, polygon {
            stroke-dasharray: 1000;
            stroke-dashoffset: 1000;
            animation: draw 5s linear forwards;
          }
          @keyframes draw {
            to { stroke-dashoffset: 0; }
          }
        `}</style>
                </defs>

                {(() => {
                    const fib = [1, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144, 233, 377, 610];
                    const baseDistance = 21;
                    const lines = [];

                    lines.push(
                        <line key="v" x1="400" y1="0" x2="400" y2="800" stroke="white" strokeWidth="1" />,
                        <line key="h" x1="0" y1="400" x2="800" y2="400" stroke="white" strokeWidth="1" />
                    );

                    for (let i = 0; i < fib.length; i++) {
                        const offset = fib[i] * baseDistance;
                        const leftX = 400 - offset;
                        const rightX = 400 + offset;

                        lines.push(
                            <line key={`l${i}`} x1={leftX} y1="0" x2={leftX} y2="800" stroke="white" strokeWidth="1" />,
                            <line key={`r${i}`} x1={rightX} y1="0" x2={rightX} y2="800" stroke="white" strokeWidth="1" />,
                            <line key={`t${i}`} x1="0" y1={leftX} x2="800" y2={leftX} stroke="white" strokeWidth="1" />,
                            <line key={`b${i}`} x1="0" y1={rightX} x2="800" y2={rightX} stroke="white" strokeWidth="1" />,
                            <circle key={`c${i}`} cx="400" cy="400" r={offset} stroke="white" strokeWidth="1" fill="none" />
                        );
                    }
                    return display === 'none' ? null : lines;
                })()}

                <circle cx="400" cy="400" r="255" stroke="white" strokeWidth="34" fill="none" />

                {[...Array(12)].map((_, i) => {
                    const rayRadius = 34;
                    const angle = ((360 / 12) * i * Math.PI) / 180;
                    const x = 400 + 180 * Math.sin(angle);
                    const y = 400 - 180 * Math.cos(angle);
                    const ax = 400 + 180 * Math.sin(angle + rayRadius / 180);
                    const ay = 400 - 180 * Math.cos(angle + rayRadius / 180);
                    const bx = 400 + 180 * Math.sin(angle - rayRadius / 180);
                    const by = 400 - 180 * Math.cos(angle - rayRadius / 180);

                    return display !== 'none' ? (
                        <React.Fragment key={i}>
                            <circle cx={x} cy={y} r={rayRadius} stroke="white" strokeWidth="1" fill="none" />
                            <line x1="400" y1="400" x2={ax} y2={ay} stroke="white" strokeWidth="1" mask="url(#donutMask)" />
                            <line x1="400" y1="400" x2={bx} y2={by} stroke="white" strokeWidth="1" mask="url(#donutMask)" />
                        </React.Fragment>
                    ) : (
                        <React.Fragment key={i}>
                            <circle cx={x} cy={y} r={rayRadius} fill={rayData[i % rayData.length].color} />
                            <polygon
                                points={`400,400 ${ax},${ay} ${bx},${by}`}
                                fill={rayData[i % rayData.length].color}
                                mask="url(#donutMask)"
                            />
                        </React.Fragment>
                    );
                })}

                <text
                    x="400"
                    y="400"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize="89"
                    fill={display === 'none' ? '#444' : 'white'}
                    fontWeight="900"
                >
                    @
                </text>
            </svg>
        </div>
    );


    return <>
        <Helmet>
            <title>Brand Guidelines | Sparkling Email</title>
            <meta name="description" content="Comprehensive brand guidelines for Sparkling Email" />
            <meta name="keywords" content="brand, guidelines, sparkling email, logo, colors, design system" />
            <meta name="author" content="Sparkling Email" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta property="og:title" content="Brand Guidelines | Sparkling Email" />
            <meta property="og:description" content="Comprehensive brand guidelines for Sparkling Email" />
            <meta property="og:image" content="https://sparklingemail.com/logo.png" />
            <meta property="og:url" content="https://sparklingemail.com/brand-guidelines" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Sparkling Email" />
            <meta property="og:locale" content="en_US" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Brand Guidelines | Sparkling Email" />
            <meta name="twitter:description" content="Comprehensive brand guidelines for Sparkling Email" />
            <meta name="twitter:image" content="https://sparklingemail.com/logo.png" />
            <meta name="twitter:site" content="@sparklingemail" />
            <meta name="twitter:creator" content="@sparklingemail" />
        </Helmet>
        <section className="container py-5 text-dark">
            <div className="row justify-content-center mb-5 text-center">
                <div className="col-12 col-md-8">
                    <h1 className="display-4">Brand Guidelines</h1>
                    <p className="lead">Explore the story, design philosophy, color system, and service mapping behind Sparkling Email’s identity.</p>
                </div>
            </div>

            <div className="row justify-content-center mb-3">
                <div className="col-12 col-xl-8">
                    <h2>Logo Story & Concept</h2>
                    <p>
                        At the center of our logo sits the iconic <span className="fw-bold fs-6" title="Email Symbol">@</span> symbol a universal marker of digital communication. Originally adapted by Ray Tomlinson in 1971 for email addresses, the @ sign was chosen for its rarity in user names and its inherent meaning: “at,” indicating a user located on a specific host. This seemingly simple symbol came to represent the heart of email infrastructure—and now anchors our brand identity.
                    </p>
                    <p>
                        Surrounding it, twelve rays radiate outward in a circular spectrum, each symbolizing a core function of Sparkling Email. Much like a beam of white light passing through a glass prism and refracting into visible color, your message enters our server-side system, is analyzed, translated, filtered, and reassembled with clarity in the target language. Each ray represents a step in this transformation journey—from secure intake to multilingual output—capturing our core metaphor: the <em>Prism of Communication</em>.
                    </p>
                    <ul>
                        <li><strong>Input:</strong> White-light message enters our server-side prism</li>
                        <li><strong>Refraction:</strong> The message is analyzed, translated, and secured</li>
                        <li><strong>Output:</strong> A coherent, multilingual message emerges seamlessly</li>
                    </ul>
                </div>
            </div>

            <div className="d-flex justify-content-center mb-3" onClick={handleClick}>
                {drawLogo()}
            </div>

            <div className="row justify-content-center mb-5">
                <div className="col-12 col-xl-8">
                    <h2>Color System & Service Mapping</h2>
                    <p>Each colored ray represents a distinct capability within Sparkling Email’s ecosystem. Their varying lengths embody the relative impact and reach of each function—from foundational layers like secure delivery and integration to high-visibility features like real-time translation and leak detection. Together, they form a radiant spectrum of services, unified in purpose yet diverse in expression—just like refracted light emerging from a prism.</p>
                    <ul className="list-unstyled">
                        {rayData.map((ray, index) => (
                            <li className="d-flex align-items-start mb-3" key={index}>
                                <span style={{ backgroundColor: ray.color, width: '1.75rem', height: '1.75rem', borderRadius: '50%', display: 'inline-block', marginRight: '1rem' }}></span>
                                <div>
                                    <strong>{ray.name}</strong> <span className="text-muted fs-7">({ray.color} - {ray.percentage}%)</span><br />
                                    <em>{ray.title}</em>: {ray.description}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-12 col-xl-8">
                    <h2>Ray Proportions & Meaning</h2>
                    <p>
                        The length of each ray follows a hidden logic—drawn from the physics of light itself. Just as visible colors emerge from white light at specific wavelengths, each ray in our design grows in proportion to its place in the color spectrum. From <strong>Orchid Pulse</strong> at 420 nm (scaled to 42%) to <strong>Coral Flash</strong> at 620 nm (100%), the visual flow reflects the expanding influence of each capability.
                    </p>
                    <p>
                        We use the formula: <code className='text-muted fw-bold'>length % = (wavelength − 420) / (620 − 420) × 100</code>, mapping natural light behavior into visual structure. This creates a sense of rhythm: the shorter rays signal swift entry actions like translation, the mid-lengths anchor core operations like security and sentiment, and the longest beam signals maximum alert and visibility—leak detection.
                    </p>
                    <p>
                        Between them, muted gray-blue rays provide structural balance—quiet pillars in the prism’s architecture, like infrastructure doing its work in silence.
                    </p>
                </div>
            </div>
        </section >
    </>
}

export default PageBrandGuidelines;